import { Button, Grid, Typography } from "@mui/material";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill";

export function Failed({ onRetry }: { onRetry: () => void }) {
  return (
    <Grid container sx={{ gap: 0.8, flexWrap: "nowrap", alignItems: "center", width: "100%" }}>
      <Typography variant="subtitle2" color="error">
        An error occurred while validating the report
      </Typography>
      <HorizontalFill />
      <Button
        color="error"
        onClick={(evt) => {
          evt.stopPropagation();
          onRetry();
        }}
      >
        Try Again
      </Button>
    </Grid>
  );
}
